// extracted by css-extract-rspack-plugin
export default {"columns":"columns-dbctJP","facts":"facts-ZJr3Tp","fact":"fact-xWc9k2"};